export enum ThemeType {
  Tcb = "tcb-theme",
  Bask = "bask-theme",
  TcbLoading = "tcb-loading-theme",
  BaskLoading = "bask-loading-theme"
}
